import { Link, useLocation } from "react-router";
import { PageShell } from "../../ui/PageShell";

export function NotFoundPage() {
  const location = useLocation();
  return (
    <PageShell title="Page not found" narrow>
      <p>
        There is nothing at <code>{location.pathname}</code>.
      </p>
      <div className="row">
        <Link className="btn btn-primary" to="/">
          Go to the town
        </Link>
        <Link className="btn" to="/directory">
          Directory
        </Link>
        <Link className="btn" to="/stats">
          Statistics
        </Link>
      </div>
    </PageShell>
  );
}
